import { useMemo, useState } from "react";

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from "@mui/material";

import { globalText } from "../../../../../assets/texts";
import { type BillingProfileInvoiceBucket } from "../../../BillingProfileForm.models";
import BucketNameField from "./BucketNameField";

type Props = {
  onClose: () => void;
  updateBucketName: (name: string) => void;
  bucket: BillingProfileInvoiceBucket;
};

const BucketEditForm = ({ updateBucketName, onClose, bucket }: Props) => {
  const [bucketName, setBucketName] = useState<string>(bucket?.name ?? "");
  const [bucketNameHasError, setBucketNameHasError] = useState<boolean>(false);

  const isSubmitDisabled = useMemo(() => bucketNameHasError || !bucketName.trim(), [bucketName, bucketNameHasError]);

  const onSubmit = () => {
    updateBucketName(bucketName);
    onClose();
  };

  return (
    <Dialog open={true} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle id="form-dialog-title">Edit invoice bucket name</DialogTitle>
      <DialogContent>
        <BucketNameField
          bucketName={bucketName}
          setBucketName={setBucketName}
          setBucketNameHasError={setBucketNameHasError}
        />
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          {globalText.CANCEL}
        </Button>
        <Button color="primary" variant="contained" onClick={onSubmit} disabled={isSubmitDisabled}>
          Edit name{" "}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BucketEditForm;
